import { EnvData, EnvSettings, generateEnv } from './models';
import * as params from './environment.json';

export const environment: EnvData = generateEnv(params as EnvSettings);
